export default {
  list: ({ list }) => list,
  total: ({ total }) => total,
  totalSum: ({ totalSum }) => totalSum,
  selected: ({ selected }) => selected,
  tableOptions: ({ tableOptions }) => tableOptions,

  customers: ({ customers }) => customers,
};
